import React, { useEffect, useState } from "react";
import "../Styles/ForwardClientPopup.css";
import {
  forward_to_client,
  get_profiles_by_agents,
  get_profiles_by_client,
} from "../api/serverWrapper";
import { USER_ID } from "../utils/store-data-constants";
import { getData } from "../utils/store-data";

export const Liked = 1;
export const UnLiked = 2;
export const Saved = 3;
export const Shared = 4;

export default function ForwardClientPopup({
  clients,
  profileId,
  handelForwardClientPopup,
  ClientId,
  isAgentLogin,
}) {
  console.log("logs for client for", clients, profileId);

  const [selectedGender, setSelectedGender] = useState("female");
  const [search, setSearch] = useState("");
  const [selectedClients, setSelectedClients] = useState([]);
  const [Profiles, setProfiles] = useState([]);

  const toggleSelect = (client) => {
    setSelectedClients((prev) =>
      prev.find((c) => c.ProfileId === client.ProfileId)
        ? prev.filter((c) => c.ProfileId !== client.ProfileId)
        : [...prev, client],
    );
  };

  const filteredClients = Profiles?.filter(
    (c) =>
      c.User.FirstName.toLowerCase().includes(search.toLowerCase()) &&
      c.ProfileId !== profileId.ProfileId &&
      c.ProfileId !== ClientId,
  );

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    let id = await getData(USER_ID);
    if (isAgentLogin) {
      let clientresp = await get_profiles_by_agents(id);
      setProfiles(clientresp.data);
    } else {
      let clientresp = await get_profiles_by_client(id);
      setProfiles(clientresp.data);
    }
  };

  const forwardToClient = async () => {
    // console.log("selectedClients",selectedClients);
    if (selectedClients.length < 0) {
      alert("Please Select the Cleints");
    }

    console.log("selectedClients", selectedClients);

    // return
    const matchData = selectedClients.map((client) => {
      const obj = {
        Client1: client.ProfileId,
        Client2: profileId.ProfileId,
        C1AgentId: isAgentLogin ?  client.AgentId : client.ClientId,
        C1AgentStatus: Shared,
        C2AgentId: profileId.BusinessDetails?.UserId ?? null,

        // Client1: profileId.ProfileId,
        // Client2: client.ProfileId,
        // C1AgentId: profileId.BusinessDetails.UserId,
        // C1AgentStatus: Shared,
        // C2AgentId: client.BusinessDetails?.UserId ?? null,
        C2AgentStatus: 1,
      };

      // Remove C2AgentId if it's null or undefined
      if (!obj.C2AgentId) {
        delete obj.C2AgentId;
      }

      return obj;
    });

    console.log("matchData:", matchData);
    // return

    let resp = await forward_to_client(matchData);
    console.log("matchData resp", resp);

    if (resp.success) {
      handelForwardClientPopup();
      const toast = document.getElementById("custom-toast-forward");
      toast.style.display = "block";

      setTimeout(() => {
        toast.style.display = "none";
      }, 3000);
    }
  };

  return (
    <div className="forward-popup-overlay">
      <div className="forward-popup-container">
        <div className="forward-popup-container-inside">
          <div className="forward-popup-header">
            <div className="d-flex align-items-center gap-2">
              {" "}
              <img
                className="forward-img"
                src={require("../assests/images/forward-to-client.png")}
                alt=""
              />{" "}
              <span className="title-for-popup">
                Forward profile to different{" "}
                {isAgentLogin ? "client" : "contact"}
              </span>
            </div>

            <span
              className="forward-popup-close click-effect"
              onClick={handelForwardClientPopup}
            >
              ✕
            </span>
          </div>

          <div className="forward-popup-divider-line"></div>

          <div className="forward-popup-search">
            <input
              type="text"
              placeholder={isAgentLogin ? "Search client" : "Search contact"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* <div className="forward-popup-toggle">
          <button
            className={selectedGender === "male" ? "active" : ""}
            onClick={() => setSelectedGender("male")}
          >
            Male clients
          </button>
          <button
            className={selectedGender === "female" ? "active" : ""}
            onClick={() => setSelectedGender("female")}
          >
            Female clients
          </button>
        </div> */}

          <div className="forward-client-list">
            {filteredClients
              ?.filter((item) => item.ProfileId !== profileId.ProfileId)
              .map((client) => (
                <div
                  key={client.ProfileId}
                  className={`forward-client-item ${
                    selectedClients.find(
                      (c) => c.ProfileId === client.ProfileId,
                    )
                      ? "selected"
                      : ""
                  } `}
                  onClick={() => toggleSelect(client)}
                >
                  <label
                    className="custom-checkbox-for-forwarded-client"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      type="checkbox"
                      checked={
                        !!selectedClients.find(
                          (c) => c.ProfileId === client.ProfileId,
                        )
                      }
                      onChange={() => toggleSelect(client)}
                    />
                    <span className="checkbox-mark"></span>
                  </label>

                  <img
                    src={
                      client?.User?.ProfilePhotoUrl ??
                      "https://randomuser.me/api/portraits/women/44.jpg"
                    }
                    alt="avatar"
                  />
                  <span>
                    {client.User.FirstName} {client.User.LastName}
                  </span>
                </div>
              ))}
          </div>
        </div>

        <div className="forward-selected-tags">
          <div className=" selected-forwred-client">
            {selectedClients.map((client) => (
              <span key={client.id} className="tag">
                {client.User.FirstName} {client.User.LastName}
                <button
                  className="click-effect"
                  onClick={() => toggleSelect(client)}
                >
                  X
                </button>
              </span>
            ))}
          </div>
          <button className="forward-send-button" onClick={forwardToClient}>
            <img
              src={require("../assests/images/send-client-to-other-icon.png")}
              alt=""
              className="forward-img"
            />
          </button>
        </div>
      </div>
    </div>
  );
}
